module.exports = __webpack_public_path__ + "static/img/GlassesMan-2.3ca067ad.png";